import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "@vds/modals";
import { Text } from '@vds/core';
import { Row, Col } from '@vds/grids';
import { MarginSpacerM, MarginSpacerS } from "common/components/styleTag";
import { useSelector } from "react-redux";
import SessionCartId from "common/components/SessionCartId/SessionCartId";
import styled from "styled-components";
import { TitleLockup } from "@vds3/type-lockups";

const MaximumDevicesModal = ({
  deviceQuantity,
  opened,
  onOpenedChange,
  ...props
}) => {
  const { t } = useTranslation(["app"]);

  const callText = t(
    "app.common.maximumDevicesExitModal.callExpert.availability"
    , { ns: "app" }
  );
  const chatText = t(
    "app.common.maximumDevicesExitModal.chatExpert.availability"
    , { ns: "app" }
  );


  const appData = useSelector((state) => state.GlobalData);
  let sessionCartData =appData?.sessionCartData?.apiResponse?.prospectFlowData

  useEffect(() => {
    try {
      if (typeof window['lpTag'] != 'undefined' && lpTag?.section && window?.lpTag?.newPage) {
        lpTag.section = manipulateLpTagSections();
        setTimeout(() => {
          window?.lpTag?.newPage(window?.location?.href, {
            section: lpTag.section,
          });
        }, 8000);
      }
    } catch (e) {
      console.error(e);
    }
  }, []);

  return (
    <Modal
      ariaLabel=""
      opened={opened}
      onOpenedChange={onOpenedChange}
      disableFocusLock= {true}
      disableOutsideClick={true}
    >
      <CustomTitle >
      <TitleLockup
              data={{
                title: {
                  bold: true,
                  size: "titleLarge",
                  children: t("app.common.maximumDevicesExitModal.heading", {  maximumCartDevicesQuantity: deviceQuantity, ns: "app" }),
                }
              }}
            />
      </CustomTitle>
      <MarginSpacerM />
      <TextDiv>
      <MarginSpacerS />
      <p dangerouslySetInnerHTML={{ __html: callText }} />
      <CustomBody kind="body" size="medium" bold>
        {t("app.common.maximumDevicesExitModal.chatExpert.header", { ns: "app" })}
      </CustomBody>
      <MarginSpacerS />
      <p dangerouslySetInnerHTML={{ __html: chatText }} />
      </TextDiv>
      <ChatWrapper>
      <Row>
        <Col colSizes={{ mobile: 4, tablet: 3, desktop: 4 }}>
           <ChatDiv id="LpMaxDevicesChatModalBtn" data-lp-link-name="LpMaxDevicesChatModalBtn"></ChatDiv>  
       </Col>
      </Row>
    </ChatWrapper>
      <CartWrapper>
      <CardIdText>
      <p>{sessionCartData?.cart?.cartId &&
               <SessionCartId sessionCartData={sessionCartData}
              />}</p>
    </CardIdText>
    </CartWrapper> 
    </Modal>
    
  );
};

const ChatWrapper = styled.div`
@media screen and (max-width:767px){
  position:absolute;
  width: 97%;
  bottom:60px;
}
`

const CartWrapper = styled.div`
@media screen and (max-width:767px){
  position:absolute;
  width: 97%;
  bottom:2px;
  left:3%;
}
`

const CustomTitle= styled.div`

@media screen and (max-width:767px){
 padding-right: 40px;
 
}
`
const CustomBody= styled(Text)`
font-size:16px;
`
const TextDiv=styled.div`
p{
  margin-top:0px;

}
margin-top:0px;
margin-bottom:5px;
`
const ChatDiv=styled.div`
> div > button > svg {
  display: none;
}
> div > button {
    padding: 10px 30px;
    border-radius: 2.75rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
    line-height: 1.25rem;
    font-family: Verizon-NHG-eDS;
    font-weight: 700;
    text-align: center;
    width: auto;
    min-width: 4.75rem;
    outline: none;
    white-space: nowrap;
    letter-spacing: 0.03125rem;
    background-color: #000000;
    border: 0.0625rem solid #000000;
    color: #ffffff;
    @media screen and (max-width:767px){
      width:22rem;
    }
    `

const CardIdText=styled.div`
font-style: normal;
font-weight: 400;
font-size: 16px !important;
line-height: 20px;
margin-top: -1rem !important;
  @media screen and (max-width:767px){
    margin-left: -10px !important;
    }
`


export default MaximumDevicesModal;
